import { takeEvery, takeLatest } from "redux-saga/effects";
import { schema } from "normalizr";

import { makePayload, generateDefaultActions, requestSaga, fillDictionary } from "../utils/helpers";

export const SCREEN_PREF_KEY = "screen_pref";
export const SCREEN_PREF_ENTITY = new schema.Entity(SCREEN_PREF_KEY, {});
export const SCREEN_PREF_SCHEMA = [SCREEN_PREF_ENTITY];

const initialState = {
  screen_pref: {
  }
};
export const GET_SCREEN_PREF = generateDefaultActions("GET_SCREEN_PREF");

export const UPDATE_CONTACT_SCREEN_PREF = generateDefaultActions("UPDATE_CONTACT_SCREEN_PREF");

export const getScreenPreferences = payload => makePayload(GET_SCREEN_PREF.value, payload);

export const updateContactScreenPreferences = payload => makePayload(UPDATE_CONTACT_SCREEN_PREF.value, payload);

function* getScreenPreferencesSaga(payload) {
  const contactId = localStorage.getItem("contactId");
  const isGuest = payload.screenType === "deal_view_metric" && payload.isGuest;
  const dealId = isGuest ? payload.dealId : null;
  const fundId = payload.fundId || null;
  yield requestSaga(
    GET_SCREEN_PREF,
    `/getAllScreenPreferencesByContactIdandType?contactId=${contactId}&screenType=${payload.screenType}&checkPermissions=${isGuest}&dealId=${dealId}&fundId=${fundId}`
  );
}

function* updateContactScreenPreferencesSaga(payload) {
  yield requestSaga(
    UPDATE_CONTACT_SCREEN_PREF,
    "/updateContactScreenPreferences",
    "POST",
    { payload }
  );
  if (payload.callback) {
    payload.callback();
  }
}

export function newScreenPreferencesReducer(state = initialState, action) {
  const {
    type,
    payload
  } = action;
  switch (type) {
    case GET_SCREEN_PREF.success:
      // eslint-disable-next-line no-case-declarations
      const key = Object.keys(payload)[0];

      return fillDictionary(state, payload[key], "screen_pref", key);
    default:
      return state;
  }
}

export function* newScreenPreferencesSaga() {
  yield takeEvery(GET_SCREEN_PREF.value, getScreenPreferencesSaga);
  yield takeLatest(UPDATE_CONTACT_SCREEN_PREF.value, updateContactScreenPreferencesSaga);
}
